import {
  useStripe,
  useElements,
  PaymentElement,
  Elements, LinkAuthenticationElement,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Button from "../../UI/Button";
import {
  useAddPaymentMutation, useAffirmPaymentIntentMutation,
  useSetupIntentMutation,
} from "../../Store/Builder/techsbook.api";
import { useEffect, useState } from "react";
import {useDispatch, useSelector} from "react-redux";
import {setLoader, setPaymentModal} from "../../Store/Slice/techsbookSlice";
import showToast from "../../Global/Hooks/toast";
import useGetPaymentList from "../../Global/Api/Account/getPaymentListApi";
import useGetStripeKeyApi from "../../Global/Api/Account/getStripeKeyApi";

const CheckoutForm = ({affirm, jobId}) => {
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();
  const [addPayment] = useAddPaymentMutation();
  const getPayment = useGetPaymentList();
  const [email, setEmail] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }
    dispatch(setLoader(true));
    const redirectUrl = process.env.REACT_APP_REDIRECT_URL;
    if (!affirm) {
      stripe
        .confirmSetup({
          elements,
          confirmParams: {
            return_url: `${redirectUrl}/payment-result`,
          },
          redirect: "if_required",
        })
        .then((res) => {
          addPayment(res?.setupIntent?.payment_method)
            .unwrap()
            .then((res) => {
              dispatch(setLoader(false));
              showToast(res?.message ?? "Success", "success");
              dispatch(setPaymentModal(false));
              getPayment.get();
            })
            .catch((err) => {
              dispatch(setLoader(false));
              showToast(err?.data, "error");
            });
        })
        .catch((err) => {
          dispatch(setLoader(false));
          showToast(err?.data, "error");
        });
    } else {
      stripe
        .confirmPayment({
          elements,
          confirmParams: {
            // TODO add base url to env
            return_url: `${redirectUrl}/jobs/${jobId}`,
          },
          redirect: "if_required",
        })
        .then((res) => {
          // addPayment(res?.setupIntent?.payment_method)
          //   .unwrap()
          //   .then((res) => {
          //     dispatch(setLoader(false));
          //     showToast(res?.message ?? "Success", "success");
          //     dispatch(setPaymentModal(false));
          //     getPayment.get();
          //   })
          //   .catch((err) => {
          //     dispatch(setLoader(false));
          //     showToast(err?.data?.message ?? "Error", "error");
          //   });
        })
        .catch((err) => {
          dispatch(setLoader(false));
          showToast(err?.data?.message ?? "Error", "error");
        });
    }

  };

  const paymentElementOptions = {
    layout: "tabs"
  }

  const renderForm = () => {
    if (!affirm) {
      return <form onSubmit={handleSubmit}>
        <PaymentElement />
        <Button
          topPadding={14}
          bottomPadding={14}
          text="Save"
          disabled={!stripe}
          style={{ marginTop: 20 }}
        />
      </form>
    }

    return <form id="payment-form" onSubmit={handleSubmit}>
      <div style={{padding: '15px'}}></div>
      <LinkAuthenticationElement
        id="link-authentication-element"
        onChange={(e) => setEmail(e?.target?.value)}
      />
      <PaymentElement id="payment-element" options={paymentElementOptions} />
      <Button
        topPadding={14}
        bottomPadding={14}
        text="Continue to Affirm"
        disabled={!stripe}
        style={{ marginTop: 20 }}
      />
    </form>
  }

  return renderForm();
};

const Stripe = ({affirm, jobId, amount, paymentId}) => {

  const dispatch = useDispatch();
  const [secret, setSecret] = useState(null);
  const [getSecret] = useSetupIntentMutation();
  const [getSecretAffirm] = useAffirmPaymentIntentMutation();
  const {stripeKey} = useSelector((state) => state.rootReducer.techsbookSlice);
  const {get} = useGetStripeKeyApi();

  let stripePromise = loadStripe(stripeKey);

  const getSecretHandler = () => {
    dispatch(setLoader(true));
    if(!affirm) {
      getSecret()
        .unwrap()
        .then((res) => {
          dispatch(setLoader(false));
          setSecret(res?.client_secret);
        })
        .catch((err) => {
          dispatch(setLoader(false));
          showToast(err?.data, "error");
        });
    } else {
      getSecretAffirm({job_id: jobId, paymentId: paymentId,  amount: amount}).unwrap()
        .then((res) => {
          dispatch(setLoader(false));
          setSecret(res?.client_secret);
        })
        .catch((err) => {
          dispatch(setLoader(false));
          showToast(err?.data, "error");
        });
    }
  };

  const options = {clientSecret: secret};

  useEffect( () => {
    get();
    getSecretHandler();
  }, []);

  return (
    secret !== null && (
      <Elements stripe={stripePromise} options={options}>
        <CheckoutForm affirm={affirm} jobId={jobId} amount={amount}/>
      </Elements>
    )
  );
};

export default Stripe;
